import { createDomainApi, type ExtractEntityType } from '@skylabs-digital/react-proto-kit';

import { webhookDeliverySchema } from '../schemas/webhookDelivery.schema';

export const createWebhookDeliveriesApi = (webhookId: string) =>
  createDomainApi(`webhooks/${webhookId}/deliveries`, webhookDeliverySchema);

export type WebhookDeliveryEntity = ExtractEntityType<
  ReturnType<typeof createWebhookDeliveriesApi>
>;
